<div
  [ngClass]="{ disabled: _disabled }"
  (click)="downOnce()"
  class="qty qty-remove action"
>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#1D1D1D" />
    <line x1="19" y1="12" x2="5" y2="12" stroke="black" />
  </svg>
</div>
<div [ngClass]="{ disabled: _disabled }" class="qty px-3 qty-no">
  {{ lineItem.quantity }}
</div>
<div
  [ngClass]="{ disabled: _disabled }"
  (click)="upOnce()"
  class="qty qty-add action"
>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#1D1D1D" />
    <line x1="12" y1="19" x2="12" y2="5" stroke="black" />
    <line x1="19" y1="12" x2="5" y2="12" stroke="black" />
  </svg>
</div>
